import { render, staticRenderFns } from "./indexAdd.vue?vue&type=template&id=7869ab48&scoped=true"
import script from "./indexAdd.vue?vue&type=script&lang=js"
export * from "./indexAdd.vue?vue&type=script&lang=js"
import style0 from "./indexAdd.vue?vue&type=style&index=0&id=7869ab48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7869ab48",
  null
  
)

export default component.exports